import { render, staticRenderFns } from "./marsList.vue?vue&type=template&id=423c46dc&scoped=true&"
import script from "./marsList.vue?vue&type=script&lang=js&"
export * from "./marsList.vue?vue&type=script&lang=js&"
import style0 from "./marsList.vue?vue&type=style&index=0&id=423c46dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c46dc",
  null
  
)

export default component.exports